import { VisibilitySchedulesOptions } from '../../../../settings/types';

import { SetUsersSeeOtherSchedulesOptionProps } from './visibilitySchedules.types';

export const useVisibilitySchedules = () => {
  const setUsersSeeOtherSchedulesOption = ({
    value,
    usersCanSeeSchedulesInOtherLocations,
    usersCanSeeSchedulesForOtherPositions,
  }: SetUsersSeeOtherSchedulesOptionProps): void => {
    switch (value) {
      case VisibilitySchedulesOptions.accessPositionsEnabled:
        usersCanSeeSchedulesForOtherPositions.onChange(true);
        break;
      case VisibilitySchedulesOptions.accessPositionsDisabled:
        usersCanSeeSchedulesForOtherPositions.onChange(false);
        break;
      case VisibilitySchedulesOptions.accessPositionsEnabledLocationsEnabled:
        usersCanSeeSchedulesForOtherPositions.onChange(true);
        usersCanSeeSchedulesInOtherLocations.onChange(true);

        break;
      case VisibilitySchedulesOptions.accessPositionsEnabledLocationsDisabled:
        usersCanSeeSchedulesForOtherPositions.onChange(true);
        usersCanSeeSchedulesInOtherLocations.onChange(false);
        break;
      case VisibilitySchedulesOptions.accessPositionsDisabledLocationsEnabled:
        usersCanSeeSchedulesForOtherPositions.onChange(false);
        usersCanSeeSchedulesInOtherLocations.onChange(true);
        break;
      case VisibilitySchedulesOptions.accessPositionsDisabledLocationsDisabled:
        usersCanSeeSchedulesForOtherPositions.onChange(false);
        usersCanSeeSchedulesInOtherLocations.onChange(false);
        break;

      default:
        break;
    }
  };

  return { setUsersSeeOtherSchedulesOption };
};
